import { NotificationMessagesContainer } from '../../features/master-data/notification-messages/NotificationMessagesContainer';
import {
  compose,
  withAuthorized,
  withBaseLayout,
  withHelmet
} from '../../core';

export const MasterDataNotificationMessages = compose(
  withAuthorized,
  withBaseLayout,
  withHelmet({
    title: 'Splashworks: Notification Messages'
  })
)(NotificationMessagesContainer);
